import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  cssVariables: true,
  components: {
    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState }) =>
          ownerState.variant === "standard"
            ? {
                border: `1px solid var(--mui-palette-${ownerState.colorSeverity}-main)`,
              }
            : {},
      },
    },
    MuiChip: {
      styleOverrides: {
        label: { fontWeight: 700 },
        outlined: { borderWidth: 2 },
      },
    },
    MuiCssBaseline: {
      styleOverrides: (theme) => ({
        "*": {
          scrollbarWidth: "thin",
          scrollbarColor: `${theme.vars.palette.background.textMuted} transparent`,
        },
        "*::-webkit-scrollbar": { width: 8, height: 8 },
        "*::-webkit-scrollbar-track": { backgroundColor: "transparent" },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: theme.vars.palette.background.textMuted,
        },
      }),
    },
  },
  colorSchemes: {
    light: {
      palette: {
        // primary.main should always match the hex code of DEFAULT_LOOKUP_COLOR in lookups.js
        primary: { main: "#659ee0", dark: "#0D47A1", contrastText: "#FFFFFF" },
        error: { main: "#d32f2f", dark: "#B71C1C" },
        warning: { main: "#eda053" },
        info: { main: "#2185be" },
        success: { main: "#2e7d32", contrastText: "#FFFFFF" },
        archived: { main: "#8797ad", dark: "#475569", contrastText: "#FFFFFF" },
        background: {
          page: "#F5F8FC",
          tableHeader: "#d8e7f8",
          tableBody: "#EAF2FB",
          tableHeaderText: "#0D3A66",
          appBar: "#33659d",
          text: "#0D3A66",
          textMuted: "#5A7896",
          progressTrack: "#9fc9f6",
          cardBackground: "#FFFFFF",
          dialog: "#EAF2FB",
        },
        appBarAvatar: {
          main: "rgba(255,255,255,0.18)",
          contrastText: "#ffffff",
        },
        login: {
          background: "#eef4fc",
          heading: "#001e3c",
          accent: "#00A8E0",
          eyebrow: "#2a6db5",
          headingSecondary: "#1a5296",
          body: "rgba(0,30,60,0.72)",
          footer: "rgba(0,30,60,0.50)",
          nowLabel: "#001e3c",
          nextLabel: "#1a4a80",
          laterLabel: "#2a6db5",
          nextDot: "#659ee0",
          laterDot: "#5A7896",
          completeDot: "#708090",
          gradientCyan: "rgba(0,168,224,0.15)",
          gradientBlue: "rgba(51,101,157,0.12)",
          nowCardAccent: "rgba(0,168,224,0.22)",
          nowBorder: "rgba(0,168,224,0.38)",
          nowGlow: "rgba(0,168,224,0.55)",
          columnGap: "rgba(0,30,60,0.08)",
          cardFgRgb: "0,30,60",
          msButtonBg: "#ffffff",
          msButtonBgHover: "#f5f6f8",
          msButtonBorder: "#d0d3d9",
          msButtonText: "#2b2b2b",
          msButtonShadow: "rgba(0,20,45,0.28)",
          msButtonShadowHover: "rgba(0,20,45,0.40)",
          msLogoRed: "#f25022",
          msLogoGreen: "#7fba00",
          msLogoBlue: "#00a4ef",
          msLogoYellow: "#ffb900",
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: "#90CAF9",
          dark: "#42A5F5",
          contrastText: "#000000DE",
        },
        error: { main: "#ff4848", dark: "#D32F2F" },
        warning: { main: "#ffa927" },
        info: { main: "#29B6F6" },
        success: { main: "#81d385", contrastText: "#121212" },
        archived: { main: "#cad7e7", dark: "#64748B", contrastText: "#0D1B2A" },
        background: {
          page: "#0D1B2A",
          tableHeader: "#1b3553",
          tableBody: "#29486b",
          tableHeaderText: "#90CAF9",
          appBar: "#0D2B45",
          text: "#FFFFFF",
          textMuted: "#A8C4E0",
          progressTrack: "#18304a",
          cardBackground: "#305985",
          dialog: "#01244c",
        },
        appBarAvatar: {
          main: "rgba(255,255,255,0.18)",
          contrastText: "#ffffff",
        },
        login: {
          background: "#002850",
          heading: "#ffffff",
          accent: "#00A8E0",
          eyebrow: "#4f8fca",
          headingSecondary: "#9fc9f6",
          body: "rgba(234,242,251,0.72)",
          footer: "rgba(159,201,246,0.50)",
          nowLabel: "#eaf2fb",
          nextLabel: "#cfe0f2",
          laterLabel: "#9fc9f6",
          nextDot: "#659ee0",
          laterDot: "#5A7896",
          completeDot: "#708090",
          gradientCyan: "rgba(0,168,224,0.20)",
          gradientBlue: "rgba(51,101,157,0.34)",
          nowCardAccent: "rgba(0,168,224,0.28)",
          nowBorder: "rgba(0,168,224,0.45)",
          nowGlow: "rgba(0,168,224,0.70)",
          columnGap: "rgba(255,255,255,0.055)",
          cardFgRgb: "255,255,255",
          msButtonBg: "#ffffff",
          msButtonBgHover: "#f5f6f8",
          msButtonBorder: "#d0d3d9",
          msButtonText: "#2b2b2b",
          msButtonShadow: "rgba(0,20,45,0.28)",
          msButtonShadowHover: "rgba(0,20,45,0.40)",
          msLogoRed: "#f25022",
          msLogoGreen: "#7fba00",
          msLogoBlue: "#00a4ef",
          msLogoYellow: "#ffb900",
        },
      },
    },
  },
});
